export class Lot {
  /**
   *
   */
  public id: number;

  /**
   *
   */
  public label: string;

  /**
   *
   */
  public parentId: number;

  /**
   * Creates an instance of Lot.
   *
   * @param id the id
   * @param label the label
   * @param parentId the parent id
   */
  public constructor(id = 0, label = '', parentId = 0) {
    this.id = id;
    this.label = label;
    this.parentId = parentId;
  }
}
